export default __webpack_public_path__ + "static/media/library-search.7755ea78.svg";